export default class Map {
    constructor($map) {
        this.$canvas = $map;
        this.map = null;
        this.markers = null;
        this._init();
    }

    _init() {
        if (!document.body.classList.contains('bricks-is-frontend') || this.$canvas === null ){
            return;
        }

        const mbAttr = 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>';
        const mbUrl = 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw';

        const streets = L.tileLayer(mbUrl, {id: 'mapbox/streets-v11', tileSize: 512, zoomOffset: -1, attribution: mbAttr});

        const osm = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        });

        this.markers = L.layerGroup(); 

        const satellite = L.tileLayer(mbUrl, {id: 'mapbox/satellite-v9', tileSize: 512, zoomOffset: -1, attribution: mbAttr});

        this.map = L.map('map', {
            center: [this.$canvas.dataset.leafletLat, this.$canvas.dataset.leafletLong],
            zoom: this.$canvas.dataset.leafletZoom,
            layers: [osm, this.markers]
        });

        const baseLayers = {
            'OpenStreetMap': osm,
            'Streets': streets,
            'Satellite': satellite
        };

        const layerControl = L.control.layers(baseLayers).addTo(this.map);

        this._addMarker();
    }

    _addMarker() {
        var bounds = L.latLngBounds()
        for (let store of stores) {
            let lat_lng = [store.lat, store.long]
            var marker = L.marker(lat_lng).addTo(this.markers);
            var tel = store.tel.replaceAll(' ', '');
            marker.bindPopup( `
                <div>${store.address}</div> 
                <div>${store.cp} ${store.city}</div>
                <a href="tel:${tel}">tel: ${store.tel}</a> 
            `)
            bounds.extend(lat_lng)
        }
        if (stores.length > 1)
            this.map.fitBounds(bounds)
    }
}